import * as React from "react";
import * as Crypto from "expo-crypto";
import { ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function TypedObjectKeys<T extends object>(obj: T) {
  return Object.keys(obj) as (keyof T)[];
}

export function useForwardedRef<T>(
  forwardedRef?:
    | ((instance: T | null) => void)
    | React.MutableRefObject<T | null>,
) {
  const localRef = React.useRef<T>(null);
  return React.useMemo(
    () => ({
      get current() {
        return localRef.current;
      },
      set current(value) {
        // @ts-expect-error this is supposed to be fine
        localRef.current = value;
        if (typeof forwardedRef === "function") {
          forwardedRef(value);
        } else if (forwardedRef) {
          forwardedRef.current = value;
        }
      },
    }),
    [forwardedRef],
  );
}

export function generateObjectId() {
  return Crypto.randomUUID();
}

export function formatBytes(bytes: number, decimals: number = 2) {
  if (bytes == 0) return "0 Bytes";
  const k = 1024,
    dm = decimals || 2,
    sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}
